module.exports = __webpack_public_path__ + "static/newwhiteelephanthamper-13210b448735937fe84da74a2c12b605.jpeg";